
import Vue from "vue";
import { toPercent } from "@/util/filters";

enum AffixType {
  Attack = "ATK",
  CritDmg = "Critical DMG %",
}

enum FinalStats {
  TotalBoost = "Total boost",
  AtkBoost = "Boost from attack",
  CritDmgBoost = "Boost from critical DMG",
}

export default Vue.extend({
  name: "affix-calc",
  props: {
    valkAtk: Number,
    critDmg: Number,
    critRate: Number,
  },
  data: function () {
    return {
      // Constants.
      FinalStats: FinalStats,
      AffixType: AffixType,
      affixTypes: Object.values(AffixType),

      // Affix variables.
      affix1: 23,
      affix1Type: AffixType.Attack,
      affix2: 5.5,
      affix2Type: AffixType.CritDmg,
    };
  },
  computed: {
    calculationResults: function () {
      const affix1Atk = this.affix1Type === AffixType.Attack ? this.affix1 : 0;
      const affix2Atk = this.affix2Type === AffixType.Attack ? this.affix2 : 0;
      const overallAffixAtk = affix1Atk + affix2Atk;

      const affix1CritDmg = this.affix1Type === AffixType.CritDmg ? this.affix1 : 0;
      const affix2CritDmg = this.affix2Type === AffixType.CritDmg ? this.affix2 : 0;
      const overallAffixCritDmg = affix1CritDmg + affix2CritDmg;

      const results = {};
      results[FinalStats.AtkBoost] = overallAffixAtk / this.valkAtk;
      const critRateDecimal = this.critRate / 100;
      const nonCritRate = 1 - critRateDecimal;
      const boostCrits = 100 * nonCritRate + (this.critDmg + overallAffixCritDmg) * critRateDecimal;
      const boostNonCrits = 100 * nonCritRate + this.critDmg * critRateDecimal;
      results[FinalStats.CritDmgBoost] = boostCrits / boostNonCrits - 1;
      results[FinalStats.TotalBoost] =
        (1 + results[FinalStats.AtkBoost]) * (1 + results[FinalStats.CritDmgBoost]) - 1;

      return results;
    },
  },
  filters: {
    toPercent: toPercent,
  },
});
